export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "training_standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Training Standards"])},
        "program_standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Program Standards"])}
      },
      "fr": {
        "training_standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Normes de formation"])},
        "program_standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Normes du programme"])}
      }
    }
  })
}